import React from "react";
import { Link } from "react-router-dom";
import { useReveal } from "../lib/useReveal";
import Reveal from "./Reveal";

export default function Diagnostic() {
  const { ref, inView } = useReveal();

  return (
    <section className="section section--alt" id="diagnostic">
      <div className="container">
        <div
          className={`diagnostic reveal ${inView ? "reveal--in" : ""}`}
          ref={ref}
        >
          <div className="diagnostic__copy">
            <h2 className="section__title">
              Is your production line ready for the world stage?
            </h2>
            <p className="section__subtitle">
              Take our 60-second diagnostic. We’ll analyze your brand’s ‘Export
              Readiness’ and tell you exactly what you need to join our next
              Global Showcase.
            </p>

            <Link className="btn btn--secondary" to="/diagnostic">
              Start the 60-Second Test
            </Link>

            <div className="smallNote">
              Results appear instantly, plus a direct path to apply.
            </div>
          </div>

          <Reveal>
            <div className="panelCard panelCard--motion">
              <div className="panelCard__row">
                <div className="panelCard__pill">Export score</div>
                <div className="panelCard__pill panelCard__pill--blue">
                  Requirements
                </div>
              </div>
              <div className="panelCard__headline">60 seconds.</div>
              <div className="panelCard__text">
                Clear next steps. Zero guessing.
              </div>
              <div className="panelCard__bar" />
              <div className="panelCard__list">
                <div className="panelCard__item">Visibility & Market Proof</div>
                <div className="panelCard__item">
                  Structural Integrity & Management
                </div>
                <div className="panelCard__item">
                  Financial & Scaling Capacity
                </div>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
